import { render, staticRenderFns } from "./SalarySheetView.vue?vue&type=template&id=5a368431"
import script from "./SalarySheetView.vue?vue&type=script&lang=js"
export * from "./SalarySheetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports